$(document).ready(function(){
    $('.featuredSlider').slick({
      infinite: false,
      slidesToShow: 3.5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"><</button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  // Domain kontrolü ve hedef tutarı belirleme
  const domain = window.location.hostname;
  const freeShippingGoal = domain.endsWith('.cz') ? 3000 : 200; // .cz için 3000, diğerleri için 300
  const progressMessage = document.getElementById('progress-message');
  const progressBar = document.getElementById('progress-bar');

  // Progress bar'ı güncelleme fonksiyonu
  function updateFreeShippingProgress(cartTotal) {
    const amountRemaining = freeShippingGoal - cartTotal;
    const percentage = (cartTotal / freeShippingGoal) * 100;

    if (cartTotal >= freeShippingGoal) {
      progressMessage.innerText = domain.endsWith('.cz') 
        ? 'K tomuto nákupu máte dopravu zdarma'
        : 'You got free shipping with this order';
      progressBar.style.width = '100%';
    } else {
      progressMessage.innerText = domain.endsWith('.cz')
        ? `Nakupte ještě za ${Math.floor(amountRemaining)} Kč a získejte dopravu zdarma`
        : `Add ${Math.floor(amountRemaining)}€ more to get free shipping`;
      progressBar.style.width = `${percentage}%`;
    }
  }

  // Sepet verilerini çekme fonksiyonu
  function fetchCartData() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartTotal = data.total_price / 100; // Cent'ten normal tutara çevir
        updateFreeShippingProgress(cartTotal);
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  // Sepet güncelleme event'ini tetikleme
  document.addEventListener('cart:updated', fetchCartData);

  // Ürün sayfasındaki form submit event'ini yakalama
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(item => {
          // Sepet verilerini güncelle
          fetchCartData();
          
          // Cart drawer'ı açmak için event tetikle (eğer cart drawer eventi varsa)
          const cartDrawerEvent = new CustomEvent('cart:toggle', { detail: item });
          document.dispatchEvent(cartDrawerEvent);
        })
        .catch(error => console.error('Error adding to cart:', error));
    });
  });

  // Quick-add butonları için event ekleme
  document.querySelectorAll('.quick-add-btn').forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      // Variant ID'yi al
      const variantId = button.getAttribute('data-id') || button.querySelector('.quickCart').getAttribute('data-variant-id');
      const quantity = 1; // Varsayılan olarak 1 adet eklenecek

      // Form verisini hazırlama
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      // Sepete ürün ekleme isteği
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(cart => {
          // Sepet güncelleme event'i tetikle
          const cartUpdatedEvent = new CustomEvent('cart:updated', { detail: cart });
          document.dispatchEvent(cartUpdatedEvent);
        })
        .catch(error => console.error('Error adding to cart:', error));
    });
  });

  // Sayfa yüklendiğinde sepet verisini çek
  fetchCartData();
});





  
  